import { css } from '@emotion/react'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'next-i18next'
import { IconFactory } from 'components/IconButton'
import { unifiedColors } from 'styles/colors'
import {
  BodyContainerIncluded,
  CheckContainer,
  MainContainerIncluded,
  ServiceContainer,
  ServiceItem
} from './map/IncludedContainer.style'

interface EditionServiceType {
  type: string
}
interface EditionService {
  editionService: EditionServiceType
}
interface IncludedRaceProps {
  title: string
  editionServices: EditionService[]
}

export default function IncludedRace({
  title,
  editionServices
}: IncludedRaceProps) {
  const { t } = useTranslation('whatsincluded')
  return (
    <MainContainerIncluded>
      <BodyContainerIncluded>
        <Typography variant="h4">{title}</Typography>
        <ServiceContainer>
          {editionServices.map((serviceWrapper, index) => (
            <ServiceItem key={index} $index={index}>
              <CheckContainer>
                <IconFactory
                  icon="check"
                  css={css`
                    path {
                      stroke: ${unifiedColors.label.onGreen};
                    }
                  `}
                />
              </CheckContainer>
              {t(serviceWrapper.editionService.type)}
            </ServiceItem>
          ))}
        </ServiceContainer>
      </BodyContainerIncluded>
    </MainContainerIncluded>
  )
}
